import { RECEIVE_COUNTRIES, REQUEST_COUNTRIES } from '../actions'
import { updateOrAddItemsById } from '../helpers'

export default (
    state = {
        items: [],
        isFetching: false,
        fetchSuccessful: null,
        shouldFetch: true,
    },
    action
) => {
    const { type, data } = action

    switch (type) {
        case REQUEST_COUNTRIES:
            return { ...state, isFetching: true, shouldFetch: false }

        case RECEIVE_COUNTRIES: {
            const { items: currentItems } = state
            const { items: receivedItems } = data

            const items = updateOrAddItemsById({ currentItems, receivedItems })

            return { ...state, isFetching: false, ...data, items }
        }

        default:
            return state
    }
}
